import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HomamProvider } from "./context/HomamContext";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HomamProvider>
      <App />
    </HomamProvider>
  </React.StrictMode>
);